<template>
  <div class="mainbody" style="min-height: 40vw;">
    <div class="containerDiv"> 
      <div class="whiteBg" > 
        <div class="txtMd2" v-scroll-animate="'fade-in'"> 
          <div class="modern-ellipsis1" v-html="brief.content"></div>
          <!-- <p>
            立足集团陆港枢纽与物流商贸优势，深度融合商流、物流、资金流及信息流，精心打造优质融资资产。紧跟数据要素市场前沿趋势，借助大数据与区块链技术，全方位提升产业链资产价值，精准破解供应链企业融资瓶颈，推动物流与金融深度协同，助力产业链上下游企业紧密合作、协同发展。

          </p>
          <br/>
          <p>
            秉持行业思维，打造专业服务；凭借数据思维，优化专业运营；运用生态思维，构建专业平台。全力开发应收账款融资、存货融资、预付款融资等创新供应链金融产品，为集团资产与营收规模的持续增长，提供坚实有力的综合服务平台支撑。
          </p> -->
        </div>
        <div class="imgMd2" > 
          <!-- <img src="../../assets/img3/yewubankuai1/2.png" /> -->
          <!-- <img src="../../assets/ywbkNew/2/item6-1.png" /> -->
          <CarouselHomeyewubankuai class="showImg" ref="carusel0" :imgList="brief.imgList" :heightParam="heightParam" />
        </div>
      </div>
 
     

    </div>
   </div>
</template>

<script>
// import Modules3 from '@/components/gk/Modules3.vue'
import CarouselHomeyewubankuai from '@/components/carousel_home/indexyewubankuai.vue'
import API from '@/api/bsInfo'


export default {
 components: {
  CarouselHomeyewubankuai
 },
 data() {
   return {

    urlBase: process.env.VUE_APP_BASE_API,
    heightParam:'26vw',
   indexNum:null,
   indexNum1:null,
   
      zhongouData:{},
      brief:{},
    
     
   }
 },
 props: {
   
 },
 mounted() {
     this.zhongoubanlieData();
   },
 methods: {
     //获取页面数据
     async zhongoubanlieData() {
      try {
        let objParams={
          catId:'fc5e9d6e657f405e87b929a002745893'
        }
        const res = await API.zhongoubanlieData(objParams)
        this.$nextTick(()=>{
          this.zhongouData = res.data
          this.brief=res.data.brief

          let imgarr=res.data.brief.photo.split('|').slice(1)
              let imgList=[]
              imgarr.forEach(item1=>{
                imgList.push({
                          src: this.urlBase+item1,
                          line1: ' ',
                          line2: ' ',
                        })
              })
             
              this.brief['imgList']=imgList
          
          console.log('获取成功', res.data.resultData)
        })
       
      } catch (error) {
        console.error('获取失败', error)
      }
    },

 },
}
</script>

<style lang="scss" scoped>
::v-deep .img_item{
  padding-top: 0 !important;
}
 .mainbody{
   width: 100%
   // background: #dde8f4;
   // margin-block: 100px;
   // background:url('../../assets/img3/gaikuang1/chanyepng.png');
 // background-size: 100% 100%;
 // .modules0{
 // 	width: 100%;
 // 	margin: 0 auto;
 // }
    
 }
 .containerDiv{
 width: 100%;
   // background: #dde8f4;
   // margin-block: 100px;
  //  background:url('../../assets/img3/gaikuang1/chanyepng.png');
//  background-size: 100% 100%;
 @media screen and (max-width: 768px) {
   background-size: auto 100%;
 }
 }

 .whiteBg{
   width: 90vw;
   margin:0 auto;
  //  margin-bottom: 5rem;
  //  padding:2rem 0;
  //  background:url('../../assets/img3/yewubankuai1/2.png') no-repeat;
    // background-size: auto 100%;
    // background-position: right;
  //  background:linear-gradient(to bottom, rgba(252, 253, 253, 0), rgb(251, 252, 252,0.8))
  display: flex;
  @media screen and (max-width: 768px) {
    display: block;
    }
  .txtMd2{
    width: 45vw;
    // padding-left: 5%;
    // padding:1rem;
    // padding-left:5vw;
    height: 26vw;
    padding:1rem 2rem;
    // padding:8vh;
    font-size: 1.1rem;
    line-height: 2.0rem;
    text-indent:2rem;
    color: #ffffff;
    text-align: justify;

    display: grid;
    place-items: center; /* 水平 + 垂直居中 */
  
      background-color:#015293;  
    @media screen and (max-width: 768px) {
      width: 100%;
      // color:red;
      margin-left:0;
      line-height: 2rem;
       height:auto;
    }
    p{
      font-size: 1.1rem;
    }
  }
  .txtMd2 ::v-deep(*) {
    font-size:1rem !important;
    line-height: 2rem !important;
  }
  .txtMd2 ::v-deep(p) {
     width: 100%;
     display: block;

    //  background: red;
  }
  .imgMd2{
    width:45vw;
     @media screen and (max-width: 768px) {
      width: 100%;
       
     }
    img{
      width: 100%;
      height: 100% !important;
      object-fit: cover;
    }
  }
 } 
 .modules3Container{


  position: relative;
  width: 100%;
  .modules3Item{
 
  color: #333333;
 }

 }
 .modules3Container1{
  // width: 100%;
  // background:url('../../assets/ywbkNew/1/7.png');
  // background-size: cover;
  // min-height: 50vw;
  margin-top: 2rem;
  position: relative;
  width: 100%;
  padding-bottom: 26.25%; /* 16:9 比例 (9/16=0.5625) */
  background:url('../../assets/img3/yewubankuai1/3.png');
  background-size: cover;
  background-position: center;

 }
 .modules3Div{
   width: 90vw;
   margin:0 auto;
   padding:2rem 0;
 }
 .modules3Item{
  background: none;
  border: 1px solid #a3c9fa;
  color: #ffffff;
  padding: 4rem 0;
 }
 .modules3rowDiv{
  // padding-top:3rem;
 }
 .activeYwbkItem2{
  // background-color: rgba(249, 249, 251, 0.5);  
  background: #015293;

  
   .titleModule3item{
    font-size: 1.2rem;
    font-weight: bold;
    color: #ffffff;
   }
   li{
   img{
    filter: brightness(0) invert(1); /* 将图片变为白色 */
   }
   }
 }
 .modules3Div1{
  width: 65%;
  padding-left: 5%;
  color: #ffffff;
  // background: #ffffff;
  h5{
    font-size: 1.2rem;
    padding:2rem 0;
  }
  p{
    font-size: 1rem;
    line-height: 2rem;
  }
 }
 .goDetailDiv{
  text-align: center;
  a{
    color: #015293;

  }
}


.modern-ellipsis1 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 12;

    /* 台式机 (可能更大或比例不同) */
    @media screen and (min-width: 1920px),
    screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
        -webkit-line-clamp: 12;
    }

    overflow: hidden;
    text-overflow: ellipsis;

    /* 处理内部元素 */
    >* {
        display: inline;
        /* 强制内联显示 */
        white-space: normal;
    }
}
 ::v-deep{
       @media only screen and (max-width: 767px)
        {
          .showImg{
            .el-carousel__item{
             img{
              width: 100% !important;
             }
              
            }
          }
        }
   }
 </style>